module.exports = __webpack_public_path__ + "static/media/clojure_logo.78ba9e22.png";